// constants.js
//var base_url = 'https://localhost:7258';
//var base_url = 'https://insight2-mwanapi.azurewebsites.net';
//var base_url = 'https://api2.msisolutions.co.uk';
//var base_url = "https://localhost:44349";

//export const base_url = "https://localhost:44349";
export const base_url = "https://api2-dev.msisolutions.co.uk";
//For GCP staging env use the url below
// export const base_url = window.location.origin + "/backend";

// export const ExportPdfUrl = 'http://pdfgenerator.msisolutions.co.uk/form';
export const ExportPdfUrl = "http://localhost:5000/form";

export const GetkeycloackConnectionInformationfUrl = base_url + "/api/User/GetkeycloackConnectionInformation";
export const RedirectUri = window.location.origin;

export const LoginEndPoint = base_url + "/api/User/Login";

export const GetGisTokenData = base_url + "/api/Integration/GetGisToken";

export const CurrentWorkflowStep = "currentWorkflowStep";
export const HasRedirected = "hasRedirected";

export const GetLoggedInUserData = base_url + "/api/User/GetLoggedInUserData/";
export const GetCompanyUsersData = base_url + "/api/User/GetCompanyUsersData/";
export const SendContactMessage = base_url + "/api/User/SendContactMessage/";

export const GetCompanyRolesData = base_url + "/api/Company/GetCompanyRoles/";
export const GetAllRolesDTOEndPoint = base_url + "/api/Role/GetAllRolesDTO/";

export const DeleteCompanyRolesData = base_url + "/api/Role/DeleteRoles";

export const AddUserData = base_url + "/api/User/AddUser/";

export const UnassignUserData = base_url + "/api/User/UnassignUser/";
export const SelectedCompany = "selectedCompany";
export const SelectedKeycloakCompany = "selectedKeycloakCompany";

export const GetUserCompaniesData = base_url + "/api/Company/GetUserCompanies/";
export const DeleteTransporterGeneratorData = base_url + "/api/WasteManagement/DeleteTransporterGenerator/";
export const AddTransporterGeneratorData = base_url + "/api/WasteManagement/AddTransporterGenerator/";
export const GetTransporterGeneratorsData = base_url + "/api/WasteManagement/GetTransporterGenerators/";
export const EditTransporterGeneratorsData = base_url + "/api/WasteManagement/EditTransporterGenerator/";

export const AddTransporterTruckData = base_url + "/api/WasteManagement/AddTransporterTruck/";
export const GetTransporterTrucksData = base_url + "/api/WasteManagement/GetTransporterTrucks/";
export const DeleteTransporterTruckData = base_url + "/api/WasteManagement/DeleteTransporterTruck/";
export const EditTransporterTruckData = base_url + "/api/WasteManagement/EditTransporterTruck/";

export const AddTransporterContactData = base_url + "/api/WasteManagement/AddTransporterGeneratorContact/";
export const EditTransporterContactData = base_url + "/api/WasteManagement/EditTransporterGeneratorContact/";
export const DeleteTransporterContactData = base_url + "/api/WasteManagement/DeleteTransporterGeneratorContact/";
export const GetTransporterContactsData = base_url + "/api/WasteManagement/GetTransporterGeneratorContacts/";
export const GetCRInformationByCRNumberData = base_url + "/api/Integration/GetCRInformationByCRNumber/";
export const GetCRDetails = base_url + "/api/Integration/GetCRDetails/";
export const GetBranchesCompanyEndPoint = base_url + "/api/Company/GetBranchesCompany/";
export const GetCompaniesByType = base_url + "/api/Company/GetCompaniesByType/";
export const CreateCompanyEndPoint = base_url + "/api/Company/CreateCompany";
export const MassImportEndPoint = base_url + "/api/Company/MassImport";

export const SendOtpEndPoint = base_url + "/api/User/SendOtp";

export const GetAllUsersEndPoint = base_url + "/api/User/GetAllUsers";
export const GetUserEndPoint = base_url + "/api/User/GetUser/#ID#";
export const CreateUserEndPoint = base_url + "/api/User/CreateUser";
export const CreateSubmissionEndPoint = base_url + "/api/Forms/createSubmission";

export const EditUserEndPoint = base_url + "/api/User/EditUser/";
export const DeleteUserEndPoint = base_url + "/api/User/DeleteUser/#ID#";
export const UpdatePasswordEndPoint = base_url + "/api/User/UpdatePassword/";
export const UpdateForgottenPasswordEndPoint = base_url + "/api/User/ChangeForgottenPassword";
export const ForgotPasswordRequestEndPoint = base_url + "/api/User/ForgotPasswordRequest";
export const EditUserWithoutIdEndPoint = base_url + "/api/User/EditUser";
export const GetUserCompanyByEmailEndpoint = base_url + "/api/DataBase/GetCompanyByUserEmail";

export const GetAllGroupsEndPoint = base_url + "/api/group/GetAllGroups";
export const GetAllUsersInAGroupEndPoint = base_url + "/api/group/GetAllUsersInGroup/#GroupID#";
export const GetAllGroupsByUser = base_url + "/api/group/GetAllGroupsByUser/#UserID#";
export const CreateGroupEndPoint = base_url + "/api/group/CreateGroup";

export const CompaniesGroupID = "bd062c6f-3474-4378-abc4-81346054d1ab";

export const GetAllRolesEndPoint = base_url + "/api/Role/GetAllRoles?briefRepresentation=false";
export const CreateRoleEndPoint = base_url + "/api/Role/CreateRole";
export const EditRoleEndPoint = base_url + "/api/Role/EditRole";
export const AssignRolesUsersEndPoint = base_url + "/api/Role/AssignRolesUsers";
export const UnassignRolesFromUserEndPoint = base_url + "/api/Role/UnassignRolesFromUser";
export const DeleteRoleEndPoint = base_url + "/api/Role/DeleteRole";
export const UserRolesEndPoint = base_url + "/api/Role/GetUserRoles/#ID#";

export const StartProcessEndPoint = base_url + "/api/Workflow/StartProcess/";
export const GetExecutionLocalVariableEndPoint = base_url + "/api/Workflow/GetExecutionLocalVariables";

export const StartProcessByDefinitionKeyEndPoint = base_url + "/api/Workflow/StartProcessByDefinitionKey/";
export const GetWorkflowListByAssigneeEndPoint = base_url + "/api/Workflow/GetAllWorkflowsByAssignee/";

export const GetPendingTasksEndPoint = base_url + "/api/Workflow/PendingTasks/";

export const GetWorkflowListByGroupsEndPoint = base_url + "/api/Workflow/GetAllWorkflowsByGroups/";
export const GetWorkflowListByUsersEndPoint = base_url + "/api/Workflow/GetAllWorkflowsByUsers/";

export const GetWorkflowListHistoryByAssigneeEndPoint = base_url + "/api/Workflow/GetWorkflowsHistoryByAssignee/";
export const GetWorkflowsHistoryByProcessInstance = base_url + "/api/Workflow/GetWorkflowsHistoryByProcessInstance/";

export const GetWorkflowsSubprocessEndPoint = base_url + "/api/Workflow/GetWorkflowsSubprocess/";
export const GetTaskEndPoint = base_url + "/api/Workflow/GetUserTask/";

export const VerificationEmailProcessDefinitionKey = "verification_workflow";
export const GetAllWorflowsEndpoint = base_url + "/api/Workflow/GetAllWorkflows/";
export const GetWorkflowsEndpoint = base_url + "/api/Workflow/GetWorkflows";
export const DeleteWorkflowEndPoint = base_url + "/api/Workflow/DeleteDeployment/";
export const UploadWorkflowEndPoint = base_url + "/api/Workflow/UploadAllWorkflows/";
export const CompleteTaskEndPoint = base_url + "/api/Workflow/CompleteTask/";
export const GetFormByUserTaskEndPoint = base_url + "/api/Workflow/GetFormByUserTask/";
export const GetExternalServiceTaskEndPoint = base_url + "/api/Workflow/GetExternalTask/";
export const FetchAndLockEndPoint = base_url + "/api/Workflow/FetchAndLockExternalTask/";
export const CompleteExternalTaskEndPoint = base_url + "/api/Workflow/CompleteExternalTask/";
export const GetWorkflowDiagramEndPoint = base_url + "/api/Workflow/GetDiagram/";
export const ClaimTaskEndPoint = base_url + "/api/Workflow/ClaimTask/";
export const UnclaimTaskEndPoint = base_url + "/api/Workflow/UnClaimTask/";
export const GetTaskVariables = base_url + "/api/Workflow/GetTaskVariables/";
export const DeleteProcessInstance = base_url + "/api/workflow/DeleteProcessInstance/";
export const PostregeneratePDF = base_url + "/api/workflow/regeneratePDF";
export const cloneWorkflow = base_url + "/api/workflow/cloneWorkflow/";
export const GetCountWorkflowsByGroupsEndPoint = base_url + "/api/workflow/GetCountWorkflowsByGroups/";
export const GetCountWorkflowsByUsersEndPoint = base_url + "/api/workflow/GetCountWorkflowsByUsers/";

export const VerifyEmailValidityEndPoint = base_url + "/api/DataBase/verify-email-validity";

export const PutProcessInstanceVariableEndPoint = base_url + "/api/Workflow/PutProcessInstanceVariable";

export const ModifyProcessInstanceVariableEndPoint = base_url + "/api/Workflow/ModifyProcessInstanceVariable";

export const setAssignEndPoint = base_url + "/api/Workflow/SetAssignee/";

export const GetCountTaskByAssigneeEndPoint = base_url + "/api/Workflow/GetCountTaskByAssignee/";
export const GetCountUnAssignedTaskEndPoint = base_url + "/api/Workflow/GetCountUnAssignedTask/";
export const GetAllTemplatesEndPoint = base_url + "/api/Template/GetTemplates";
export const DownloadTemplateEndPoint = base_url + "/api/Template/DownloadTemplate";

export const GetRenderEndPoint = base_url + "/api/Template/GetRender";

export const AddTemplateEndPoint = base_url + "/api/Template/AddTemplate";
export const DeleteTemplateEndPoint = base_url + "/api/Template/DeleteTemplate";

export const GetFormByIdEndPoint = base_url + "/api/Forms/form/";

export const GetAllFormsEndPoint = base_url + "/api/Forms/getForms";
export const GetFormByPathEndPoint = base_url + "/api/Forms/getFormbyPath/#FORMPATH#";
export const CreateFormEndPoint = base_url + "/api/Forms/createForm";
export const EditFormEndPoint = base_url + "/api/Forms/editForm/#FORMID#";
export const DeleteFormEndPoint = base_url + "/api/Forms/deleteForm/#FORMPATH#";
export const GetAllSubmissionsEndPoint = base_url + "/api/Forms/form/#FORMID#/submission";
export const GetAllSubmissionByIdEndPoint = base_url + "/api/Forms/getForms";

export const SendNotificationEndPoint = base_url + "/api/Notifications/send-notification";

export const SendSmsEndPoint = base_url + "/api/Integration/SendSmsMessage";
export const EfaaGetDisputeListEndPoint = base_url + "/api/integration/EfaaGetDisputeList";


export const SubmitWorkflowEndPoint = base_url + "/api/Workflow/SubmitWorkflow";

export const PostEndPoint = base_url + "/api/DataBase/Post";
export const GetEndPoint = base_url + "/api/DataBase/Get";
export const GetAllEndPoint = base_url + "/api/DataBase/GetAll";
export const DeleteDBEndPoint = base_url + "/api/DataBase/Delete/#TABLENAME#/#ITEMID#";
export const PutEndPoint = base_url + "/api/DataBase/Put";
export const PatchEndPoint = base_url + "/api/DataBase/Patch";
export const GetMenu = base_url + "/api/User/GetMenu/";
export const GetPublicMenu = base_url + "/api/User/GetPublicMenu/";
export const GetAllResourcesEndPoint = base_url + "/api/DataBase/GetAllResources";
export const DeleteDBRecordEndPoint = base_url + "/api/DataBase/DeleteRecordDTO/";
export const GetFileEndPoint = base_url + "/api/DataBase/GetFile";

export const CompanyTypesTableName = "companytype";
export const CompaniesTableName = "company";
export const LanguageTableName = "Languages";
export const SiteMapsTableName = "Menu";
export const SystemPropertiesTableName = "system_properties";
export const LabelsTableName = "Labels";

export const AccessTokenKeyInLocalStorage = "accessToken";
export const RefreshTokenKeyInLocalStorage = "refreshToken";
export const LoggedInEmailOrUserNameKeyInLocalStorage = "loggedInEmailOrUserName";
export const LoggedInRolesAttributesKeyInLocalStorage = "loggedInRolesAttributes";
export const LoggedInUserInfoKeyInLocalStorage = "loggedInUserInfo";

export const platform = "platform";

export const GetServiceSteps = base_url + "/api/Public/GetServiceSteps";
export const GetFaq = base_url + "/api/Public/GetFaq";
export const GetServiceDetails = base_url + "/api/Public/GetServiceDetails";
export const GetPageTitle = base_url + "/api/Public/GetPageTitle";
export const GetSocialLinks = base_url + "/api/Public/GetSocialLinks";
export const GetAboutUs = base_url + "/api/Public/GetAboutUs";
export const GetContactInfo = base_url + "/api/Public/GetContactInfo";
export const GetHomeSlider = base_url + "/api/Public/GetHomeSlider";
export const GetPartners = base_url + "/api/Public/GetPartners";
export const GetNews = base_url + "/api/Public/GetNews";
export const GetUserManuals = base_url + "/api/Public/GetUserManuals";
export const GetFeatures = base_url + "/api/Public/GetFeatures";
export const GetLanguageEndPoint = base_url + "/api/Public/GetLanguage";
export const GetDomainEndPoint = base_url + "/api/Public/GetDomain";
export const GetPublicFileEndPoint = base_url + "/api/Public/GetPublicFile";
export const GetPreviewEmanifest = base_url + "/api/Public/GetPreviewEmanifest";

export var RoleAttributes = [
	{ id: "Dashboards", name: "Dashboards", checked: false },
	{ id: "Users", name: "Users", checked: false },
	{ id: "Roles", name: "Roles", checked: false },
	{ id: "Forms", name: "Forms", checked: false },
	{ id: "Workflows", name: "Workflows", checked: false },
];
export const RegistrationProcessDefinitionKey = "registration_workflow";
export const TestProcessDefinitionKey = "service_process";

export const SuccessStatus = 1;
export const FailureStatus = 0;
export const LogoutStatus = -1;

export var Language = "en";
export const FormLanguages = [
	{
		label: "English",
		value: "en",
		translation: {
			en: "English",
			ar: "الانكليزية",
			fr: "Anglais",
		},
	},
	{
		label: "Arabic",
		value: "ar",
		translation: {
			en: "Arabic",
			ar: "العربية",
			fr: "Arabe",
		},
	},
	// {
	//     label: "French",
	//     value: "fr",
	//     translation: {
	//         en: "French",
	//         ar: "الفرنسية",
	//         fr: "Francais"
	//     }
	// },
];

export const VerifyEmailEndPoint = base_url + "/api/DataBase/verify-email";

export const GetSupersetGuestToken = base_url + "/api/Superset/GuestToken/";
